import { motion } from 'framer-motion';

interface LightBackgroundProps {
  variant?: 'default' | 'subtle' | 'minimal';
}

const LightBackground = ({ variant = 'default' }: LightBackgroundProps) => {
  const opacityMap = {
    subtle: { blue: 0.3, purple: 0.2 },
    default: { blue: 0.4, purple: 0.3 },
    minimal: { blue: 0.2, purple: 0.15 },
  };

  const opacity = opacityMap[variant];

  return (
    <div className="fixed inset-0 pointer-events-none overflow-hidden -z-10">
      {/* Blue background orb */}
      <motion.div
        className="absolute top-20 left-10 w-72 h-72 sm:w-96 sm:h-96 rounded-full bg-blue-100 blur-3xl"
        style={{ opacity: opacity.blue }}
        animate={{
          scale: [1, 1.05, 1],
          opacity: [opacity.blue, opacity.blue + 0.1, opacity.blue],
        }}
        transition={{ duration: 8, repeat: Infinity, ease: "easeInOut" }}
      />
      
      {/* Purple background orb */}
      <motion.div
        className="absolute bottom-20 right-10 w-80 h-80 sm:w-[28rem] sm:h-[28rem] rounded-full bg-purple-100 blur-3xl"
        style={{ opacity: opacity.purple }}
        animate={{
          scale: [1.05, 1, 1.05],
          opacity: [opacity.purple, opacity.purple + 0.1, opacity.purple],
        }}
        transition={{ duration: 8, repeat: Infinity, ease: "easeInOut", delay: 2 }}
      />

      {/* Additional accent orb for depth */}
      <motion.div
        className="absolute top-1/2 right-1/3 w-48 h-48 sm:w-64 sm:h-64 rounded-full bg-blue-50 blur-3xl"
        style={{ opacity: opacity.blue * 0.5 }}
        animate={{
          scale: [1, 1.1, 1],
          opacity: [opacity.blue * 0.4, opacity.blue * 0.6, opacity.blue * 0.4],
        }}
        transition={{ duration: 10, repeat: Infinity, ease: "easeInOut", delay: 4 }}
      />
    </div>
  );
};

export default LightBackground;
